export const aboutComparisonEs = {
  'about.problem.requires': 'Requiere:',
  'about.problem.onlyfans.body': 'Un creador que gana $10k/mes pierde $24,000 al año en comisiones.',
  'about.problem.onlyfans.requires': 'Cuenta bancaria + KYC',
  'about.problem.throne.body': 'Más conversión de moneda. Más retrasos en retiros. Limitado a 10 países.',
  'about.problem.throne.requires': 'Cuenta bancaria + KYC',
  'about.problem.linktree.body': 'O paga $40/mes por 0% de comisiones. De cualquier forma, se quedan con tu dinero.',
  'about.problem.linktree.requires': 'Cuenta bancaria + procesador de pagos',
  'about.problem.kickstarter.body': 'Más $5K-25K en costos de cumplimiento. Financiamiento todo o nada.',
  'about.problem.kickstarter.requires': 'Cuenta bancaria + KYC + cumplimiento',
  'about.problem.indiegogo.body': '5% retenido hasta la entrega. Retrasos de pago de 14 días. Flexible pero costoso.',
  'about.problem.indiegogo.requires': 'Cuenta bancaria + KYC + cumplimiento',
  'about.problem.katoa.body': 'Sin comisiones. Sin retrasos. Conserva el 100% hasta el 31 de diciembre de 2026.',
  'about.problem.katoa.requires': 'No se necesita cuenta bancaria. Sin KYC.',
  'about.problem.avgLoss': 'El creador promedio pierde',
  'about.problem.avgLossAmount': '$12,000-$24,000/año',
  'about.problem.allRequire': 'Las 5 plataformas requieren:',
  'about.problem.bankAccount': 'Cuenta bancaria',
  'about.problem.kyc': 'Verificación KYC',
  'about.problem.processors': 'Procesadores de pago',
  'about.problem.geoLimits': 'Límites geográficos',
  'about.problem.katoaRequires': 'KATOA requiere: NADA',
  'about.problem.katoaWallet': 'Solo una billetera Bitcoin Lightning. Eso es todo.',
  'about.solution.title': 'Nuestra solución: Bitcoin + descentralización',
  'about.solution.subtitle': 'Construimos KATOA sobre tecnología que hace imposibles las comisiones de plataforma.',
  'about.solution.lightning.title': 'Lightning Network',
  'about.solution.lightning.body': 'La Lightning Network de Bitcoin permite transacciones rápidas y de bajo coste a nivel global cuando la recepción Lightning esté activa (Roadmap: en curso). Sin procesador que cobre comisión. Sin retrasos de 7 días. Sin restricciones geográficas.',
  'about.solution.lightning.item1': 'Liquidaciones en menos de 1 segundo',
  'about.solution.lightning.item2': 'Funciona en más de 195 países',
  'about.solution.lightning.item3': 'Micropagos hasta satoshis',
  'about.solution.lightning.item4': 'No se requiere cuenta bancaria',
  'about.solution.nostr.title': 'Protocolo Nostr',
  'about.solution.nostr.body': 'Un protocolo social descentralizado que hace imposible la censura. Tu cuenta, tus datos, tus reglas. Ninguna empresa puede prohibirte ni explotar tu información.',
  'about.solution.nostr.item1': 'Sin suspensiones de cuenta (tú posees tus claves)',
  'about.solution.nostr.item2': 'Mensajería cifrada opcional (NIP-17)',
  'about.solution.nostr.item3': 'Pruebas de pago de conocimiento cero (hoja de ruta)',
  'about.solution.nostr.item4': 'Distribuido en relays de todo el mundo',
  'about.solution.result.title': 'El resultado: 0% de comisiones hasta el 31 de diciembre de 2026',
  'about.solution.result.body': 'Cuando los pagos fluyen de persona a persona en Bitcoin, no hay intermediario que extraiga comisiones. No es una tarifa promocional. Así funciona la tecnología.',
  'about.values.title': 'Lo que defendemos',
  'about.values.creators.title': 'Creadores primero',
  'about.values.creators.desc': 'Cada decisión prioriza las ganancias y la libertad del creador.',
  'about.values.privacy.title': 'Privacidad siempre',
  'about.values.privacy.desc': 'Recogemos lo mínimo. Pagos no custodiales. Tus claves son tuyas.',
  'about.values.global.title': 'Verdaderamente global',
  'about.values.global.desc': 'Sin discriminación geográfica. Bitcoin funciona en todas partes, para todos.',
  'about.values.censorship.title': 'A prueba de censura',
  'about.values.censorship.desc': 'Descentralizado por diseño. Ninguna empresa puede prohibirte ni controlar tu contenido.',
  'about.competitors.title': 'Por qué todos los competidores fallan',
  'about.competitors.subtitle': 'Todos comparten el mismo defecto: dependencia de los sistemas bancarios tradicionales.',
  'about.competitors.onlyfans.title': 'OnlyFans: 20% de impuesto de plataforma',
  'about.competitors.onlyfans.body': 'Un creador que gana $10K/mes pierde $2,000 al mes ($24K/año). Más riesgo de censura de Mastercard/Visa. Más suspensiones sin apelación.',
  'about.competitors.kickstarter.title': 'Kickstarter: pesadilla de cumplimiento',
  'about.competitors.kickstarter.body': '5% de plataforma + procesamiento (típicamente ~8–10% en total), más $5K-25K+ en costos de cumplimiento. Si no alcanzas la meta, recibes $0.',
  'about.competitors.indiegogo.title': 'Indiegogo: retenciones ocultas',
  'about.competitors.indiegogo.body': '8-15% en comisiones totales, incluyendo 5% retenido hasta la entrega. El financiamiento flexible suena bien hasta que retienen tu dinero.',
  'about.competitors.linktree.title': 'Linktree: monetización paga para ganar',
  'about.competitors.linktree.body': 'Nivel gratuito: 10% de comisiones. O paga $40/mes ($480/año) por 0%. De cualquier forma, pierdes dinero solo por tener una página.',
  'about.competitors.throne.title': 'Throne: las cifras del 0%',
  'about.competitors.throne.body': 'Anuncia «0% de comisiones»; el total típico ronda el 10%. El 0% solo aplica en ~10 países; en el resto pagas la diferencia.',
  'about.competitors.con.bankKyc': 'Requiere cuenta bancaria + KYC',
  'about.competitors.con.payout7': 'Retrasos de pago de 7 días',
  'about.competitors.con.payout14': 'Retrasos de pago de 14+ días',
  'about.competitors.con.censorship': 'Censura de procesadores de pago',
  'about.competitors.con.countries': 'Limitado a países compatibles',
  'about.competitors.con.fulfillment': 'Estrés de envío/cumplimiento',
  'about.competitors.con.oneTime': 'Solo financiamiento único',
  'about.competitors.con.holdback': '5% retenido hasta entrega del producto',
  'about.competitors.con.fulfillmentReq': 'Cumplimiento requerido',
  'about.competitors.con.processor': 'Requiere procesador de pagos',
  'about.competitors.con.geoRestrict': 'Restricciones geográficas',
  'about.competitors.con.feesOrSub': '9-10% de comisiones o $480/año',
  'about.competitors.con.countries50': 'Limitado a 50 países',
  'about.competitors.con.withdraw7': 'Retrasos de retiro de 7 días',
  'about.competitors.con.countries10': 'Limitado a 10 países para 0%',
  'about.competitors.con.conversion': 'Comisiones ocultas de conversión de moneda',
  'about.competitors.katoa.title': 'KATOA: la única alternativa real',
  'about.competitors.katoa.body': 'Las comisiones de red/enrutamiento Lightning las pagan los seguidores. Publicaremos cualquier cambio antes de que acabe este plazo.',
  'about.competitors.katoa.fee': '0% de comisión de plataforma hasta el 31 de diciembre de 2026',
  'about.competitors.katoa.feeDesc': 'Absorbida por Give A Bit y el apoyo de la comunidad',
  'about.competitors.katoa.payout': 'Pagos rápidos (Roadmap)',
  'about.competitors.katoa.payoutDesc': 'Vía Lightning — cuando la recepción esté disponible (Roadmap: En curso).',
  'about.competitors.katoa.bank': '✓ Sin banco necesario',
  'about.competitors.katoa.bankDesc': 'Solo una billetera Lightning.',
  'about.competitors.katoa.global': '✓ Más de 195 países',
  'about.competitors.katoa.globalDesc': 'Funciona igual en todas partes.',
  'about.audience.title': 'A quién servimos',
  'about.audience.subtitle': 'KATOA fue creado para creadores que las plataformas tradicionales ignoran.',
  'about.audience.unbanked.title': 'Los no bancarizados',
  'about.audience.unbanked.body': 'Creadores en Argentina, Nigeria, Venezuela, Vietnam. Países donde Stripe y PayPal no funcionan.',
  'about.audience.unbanked.stat': 'Más de 195 países compatibles',
  'about.audience.privacy.title': 'Los conscientes de la privacidad',
  'about.audience.privacy.body': 'Creadores que rechazan la vigilancia. Que quieren cifrado de extremo a extremo. Que exigen soberanía de datos.',
  'about.audience.privacy.stat': 'Datos mínimos, no custodial',
  'about.audience.ambitious.title': 'Los ambiciosos',
  'about.audience.ambitious.body': 'Creadores que ganan $10k-$100k+ al mes y están cansados de perder 10-20% en comisiones.',
  'about.audience.ambitious.stat': 'Ahorra $12k-$240k al año',
  'about.team.title': 'Hecho por creadores, para creadores',
  'about.team.body1': 'Somos un equipo de creadores cansados de perder 10-20% de nuestras ganancias. Así que construimos algo mejor.',
  'about.team.body2': 'No tenemos respaldo de capital de riesgo. No respondemos a inversores que exigen crecimiento a cualquier costo. Respondemos a los creadores. Por eso nunca cobraremos comisiones.',
  'about.team.promise': 'Nuestra promesa',
  'about.team.promise1': 'Nunca cobraremos comisiones de plataforma',
  'about.team.promise2': 'Nunca explotaremos tus datos',
  'about.team.promise3': 'Nunca prohibiremos creadores por contenido legal',
  'about.team.promise4': 'Siempre priorizaremos tus ganancias sobre las nuestras',
  'about.cta.title': 'Únete al movimiento',
  'about.cta.subtitle': 'Aún es pronto. Únete y quédate el 100% — 0% de comisión de plataforma hasta el 31 de diciembre de 2026.',
  'about.cta.highlight': 'Sé el siguiente.',
  'about.cta.start': 'Empieza a ganar 100%',
  'about.cta.compare': 'Ver los números',
  'about.cta.footer': 'Sin comisiones. Sin KYC. Sin trucos. Solo tú conservando el 100%.',
  'comparison.badge': 'Comparación honesta • Sin marketing',
  'comparison.earningsLabel': 'Tus ganancias mensuales (USD)',
  'comparison.savingsYearly': 'Basado en ${amount}/mes — eso son ${yearly}/año de vuelta en tu bolsillo.',
  'comparison.savingsVs': 'vs OnlyFans (${onlyfans}) · Throne (${throne}) · Linktree (${linktree})',
  'comparison.adjustCalc': 'Ajustar en la calculadora ↓',
  'comparison.breakdown.title': 'Comparación función por función',
  'comparison.table.feature': 'Función',
  'comparison.table.swipe': 'Desliza para ver más',
  'comparison.card.countries.title': 'Más de 195 países',
  'comparison.card.countries.body': '¿Sin cuenta bancaria? No hay problema. Bitcoin funciona en todas partes, para todos. Sin discriminación.',
  'comparison.card.countries.throne': 'Throne: ~10 países con 0% de comisiones',
  'comparison.card.countries.katoa': 'KATOA: Todos los países, 0% hasta el 31 dic 2026',
  'comparison.card.privacy.title': 'Privacidad real',
  'comparison.card.privacy.body': 'Recogemos lo mínimo. Pagos no custodiales. La mensajería cifrada es opcional (NIP-17). Las pruebas ZK están en la hoja de ruta.',
  'comparison.card.privacy.others': 'Otros: tus datos son su producto',
  'comparison.card.privacy.katoa': 'KATOA: no custodial, datos mínimos',
  'comparison.card.instant.title': 'Liquidación rápida (Roadmap)',
  'comparison.card.instant.body': 'Conserva el 100% de tus ganancias. Escala globalmente. Construye tu imperio sin impuestos de plataforma.',
  'comparison.card.instant.others': 'Otros: espera 7-14 días por pagos',
  'comparison.card.instant.katoa': 'KATOA: Lightning Network instantáneo (con recepción Lightning — ver Roadmap)',
  'comparison.cta.title': '¿Listo para conservar el 100%?',
  'comparison.cta.subtitle': 'Únete en esta etapa inicial. 0% de comisión de plataforma. Quédate lo que te envíen; las comisiones de Lightning siguen existiendo.',
  'comparison.cta.start': 'Empieza a ganar 100%',
  'comparison.cta.pricing': 'Ver precios (spoiler: $0)',
  'comparison.cat.fees': 'Comisiones y costos',
  'comparison.cat.banking': 'Requisitos bancarios',
  'comparison.cat.global': 'Alcance global',
  'comparison.cat.payout': 'Velocidad de pago',
  'comparison.cat.revenue': 'Modelos de ingresos',
  'comparison.cat.privacy': 'Privacidad y seguridad',
  'comparison.cat.payment': 'Funciones de pago',
  'comparison.cat.control': 'Control de plataforma',
  'comparison.feat.platformFees': 'Comisiones de plataforma',
  'comparison.feat.paymentProcessing': 'Procesamiento de pagos',
  'comparison.feat.totalFee10k': 'Comisión total sobre $10K',
  'comparison.feat.monthlySub': 'Suscripción mensual',
  'comparison.feat.withdrawalFees': 'Comisiones de retiro',
  'comparison.feat.hiddenCosts': 'Costos ocultos',
  'comparison.feat.bankRequired': 'Cuenta bancaria requerida',
  'comparison.feat.kyc': 'Verificación KYC/identidad',
  'comparison.feat.noBanking': 'Funciona sin banca',
  'comparison.feat.processorDep': 'Dependiente de procesador de pagos',
  'comparison.feat.countries': 'Países compatibles',
  'comparison.feat.sanctioned': 'Bitcoin es global',
  'comparison.feat.instantIntl': 'Transferencias internacionales rápidas (Roadmap)',
  'comparison.feat.conversion': 'Comisiones de conversión de moneda',
  'comparison.feat.payoutTime': 'Tiempo de pago',
  'comparison.feat.instantSettlement': 'Liquidación rápida (Roadmap)',
  'comparison.feat.holdback': 'Retención de fondos',
  'comparison.feat.crowdfunding': 'Crowdfunding/proyectos',
  'comparison.feat.subscriptions': 'Suscripciones (demo)',
  'comparison.feat.tips': 'Propinas/donaciones',
  'comparison.feat.digital': 'Productos digitales',
  'comparison.feat.fulfillment': 'Cumplimiento requerido',
  'comparison.feat.zk': 'Pruebas de conocimiento cero (hoja de ruta)',
  'comparison.feat.encrypted': 'Mensajería cifrada (NIP-17 opcional)',
  'comparison.feat.decentralized': 'Infraestructura descentralizada',
  'comparison.feat.censorship': 'Resistente a la censura',
  'comparison.feat.micro': 'Soporte de micropagos',
  'comparison.feat.bolt12': 'BOLT 12 recurrente (previsto)',
  'comparison.feat.lightning': 'Lightning Network',
  'comparison.feat.multiRevenue': 'Múltiples fuentes de ingresos',
  'comparison.feat.suspension': 'Riesgo de suspensión de cuenta',
  'comparison.feat.contentCensor': 'Censura de contenido',
  'comparison.feat.ownData': 'Posees tus datos',
  'comparison.feat.ownKeys': 'Posees tus claves',

  'comparison.cell.instant': 'Rápido',
  'comparison.cell.none': 'Ninguno',
  'comparison.cell.varies': 'Variable',
  'comparison.cell.included': 'Incluido',
  'comparison.cell.limited': 'Limitado',
  'comparison.cell.demo': 'Demo',
  'comparison.cell.planned': 'Previsto',
  'comparison.cell.roadmap': 'Hoja de ruta',

  'comparison.metaTitle': 'Comparación de plataformas',
  'comparison.metaDesc': 'Compara KATOA con OnlyFans, Throne, Kickstarter y más. 0% de comisión de plataforma, liquidación Lightning, sin KYC para empezar.',
} as const;